import Link from "next/link";
import { useTranslation } from "react-i18next";
import { ROUTE } from "@/route/app_routes.js";

const TAG_FILTERS = ["All", "Frontend", "Backend", "Mobile Development", "Career", "Databases"];

const tagKey = (str) =>
  String(str)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/(^_|_$)/g, "");

const BlogHero = ({ search, setSearch, activeTag, setActiveTag, resultCount }) => {

  const { t } = useTranslation("blog");

  return (
    <div className="rbt-banner-content-top rbt-course-hero-saucy">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <ul className="page-list">
              <li className="rbt-breadcrumb-item"> <Link href="/">{t("breadcrumb.home", "Home")}</Link> </li>
              <li> <div className="icon-right"> <i className="feather-chevron-right"></i> </div> </li>
              <li className="rbt-breadcrumb-item active">{t("breadcrumb.blog", "Blog")}</li>
            </ul>

            <div className="title-wrapper">
              <h1 className="title mb--0">{t("hero.title", "The SmartTech Academy Blog")}</h1>
            </div>
            <p className="description">
              {t(
                "hero.description",
                "Practical, honest writing on web and mobile development, career advice, and what we've learned building this platform's curriculum."
              )}
            </p>

            <div className="rbt-blog-search-row">
              <div className="rbt-blog-search-box">
                <i className="feather-search"></i>
                <input
                  type="text"
                  placeholder={t("hero.searchPlaceholder", "Search articles by topic, title, or tag...")}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                {search && (
                  <button
                    type="button"
                    className="rbt-search-clear-btn"
                    aria-label={t("hero.clearSearch", "Clear search")}
                    onClick={() => setSearch("")}
                  >
                    <i className="feather-x"></i>
                  </button>
                )}
              </div>

              <div className="rbt-blog-tag-filters">
                {TAG_FILTERS.map((tag) => (
                  <button
                    type="button"
                    key={tag}
                    className={`rbt-course-hero-chip ${activeTag === tag ? "active" : ""}`}
                    onClick={() => setActiveTag(tag)}
                  >
                    {tag === "All" ? t("filters.all", "All") : t(`tags.${tagKey(tag)}`, tag)}
                  </button>
                ))}
              </div>
            </div>

            {(search || activeTag !== "All") && (
              <p className="rbt-blog-result-count">
                {t("hero.resultCount", "{{count}} article found", { count: resultCount })}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogHero;
